import type { BadgeVariant } from '@/components/ui/Badge'
import type {
  TicketCategory,
  TicketPriority,
  TicketStatus,
} from '@/types/support-ticket.types'

export const SUBJECT_MIN = 3
export const SUBJECT_MAX = 150
export const MESSAGE_MAX = 5000

/** Mirrors the Input primitive's field styling for multi-line text. */
export const textareaClasses =
  'block w-full rounded-xl border border-gray-200 bg-white/95 px-3.5 py-2.5 text-sm text-gray-900 shadow-[0_1px_2px_rgba(15,23,42,0.05)] transition-all duration-150 placeholder:text-gray-400 focus:border-primary/40 focus:outline-none focus:ring-4 focus:ring-primary/10 dark:border-gray-700 dark:bg-gray-800/90 dark:text-gray-100 dark:placeholder:text-gray-500'

export const CATEGORY_OPTIONS: { value: TicketCategory; label: string }[] = [
  { value: 'question', label: 'Question' },
  { value: 'problem', label: "Something's broken" },
  { value: 'billing', label: 'Billing' },
  { value: 'feature_request', label: 'Feature request' },
  { value: 'other', label: 'Other' },
]

export const PRIORITY_OPTIONS: { value: TicketPriority; label: string }[] = [
  { value: 'low', label: 'Low' },
  { value: 'normal', label: 'Normal' },
  { value: 'high', label: 'High' },
  { value: 'urgent', label: 'Urgent' },
]

export const STATUS_META: Record<TicketStatus, { label: string; variant: BadgeVariant }> = {
  open: { label: 'Waiting on support', variant: 'neutral' },
  pending: { label: 'Support replied', variant: 'warning' },
  resolved: { label: 'Resolved', variant: 'success' },
}

function humanize(value: string): string {
  const text = value.replace(/_/g, ' ')
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export function categoryLabel(value: string): string {
  return CATEGORY_OPTIONS.find((o) => o.value === value)?.label ?? humanize(value)
}

export function priorityLabel(value: string): string {
  return PRIORITY_OPTIONS.find((o) => o.value === value)?.label ?? humanize(value)
}
